import React from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton,
  } from 'react-accessible-accordion';
import faqSlug from '../../views/Home.jsx';
import open from "../../../assets/images/open.svg";


function Faqs() {

    const queryParams = new URLSearchParams(window.location.search)
    const faqSlug = queryParams.get("faqSlug")
    console.log(faqSlug)

    return (
        <section className="faqs" id="faq">
            <div className="container mx-auto">
                <div className="text-center">
                    <h1 className="lt-white font-bold">Metafans FAQs</h1>
                </div>
            <Accordion 
            allowZeroExpanded="true"
            preExpanded={[faqSlug]}
            >
            <AccordionItem faqSlug="what" uuid="what">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <div className="lg:hidden faq-number">1</div>
                        <div className="flex justify-between items-center mt-5 xl:mt-0">
                            <div className="flex items-start gap-5 numbered-faq">
                                <div className="hidden lg:flex faq-number">1</div>
                                <h2 className="lt-white font-bold">What is MetaFans?</h2>
                            </div>
                            <div className="open-img w-[2.8rem]">
                                <img className="w-full" src={open} alt="Open FAQ"/>
                            </div>
                        </div>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel id="what-is-metafans">
                    <p className="text-grey">Created with the love of sports at its core, MetaFans is the first NFT project of its kind, connecting sports fans with VIP experiences. With our initial launch of 10,000 NFTs and a rewards-driven FanEpack NFT, our focus is on building a sports-focused web 3.0 community while collaborating with respectable brands, athletes, actors, musicians, gamers, and streamers who have the same high standards as we do.</p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem faqSlug="mint" uuid="mint">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <div className="lg:hidden faq-number">2</div>
                        <div className="flex justify-between items-center mt-5 xl:mt-0">
                            <div className="w-[calc(100%-3rem)] flex items-start gap-5 numbered-faq">
                                <span className="hidden lg:flex faq-number">2</span>
                                <h2 className="lt-white font-bold">How much does it cost to mint a MetaFan NFT?</h2>
                            </div>
                            <div className="open-img w-[2.8rem]">
                                <img className="w-full" src={open} alt="Open FAQ"/>
                            </div>
                        </div>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p className="text-grey">Minting a MetaFan will cost 0.08 Eth + gas fees until the project sells out.</p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem faqSlug="how" uuid="how">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <div className="lg:hidden faq-number">3</div>
                        <div className="flex justify-between items-center mt-5 xl:mt-0">
                            <div className="w-[calc(100%-3rem)] flex items-start gap-5 numbered-faq">
                                <span className="hidden lg:flex faq-number">3</span>
                                <h2 className="lt-white font-bold">How were MetaFans created?</h2>
                            </div>
                            <div className="open-img w-[2.8rem]">
                                <img className="w-full" src={open} alt="Open FAQ"/>
                            </div>
                        </div>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p className="text-grey">Each MetaFan is algorithmically generated by distributing 9988 assets amongst 4 avatars with varying rarities in 16 categories.</p>
                    <ul className="text-grey">
                        <li>Background</li>
                        <li>Skin</li>
                        <li>Tattoo</li>
                        <li>Eyes</li>
                        <li>Eyelashes</li>
                        <li>Eyebrows</li>
                        <li>Clothing</li>
                        <li>Necklace</li>
                        <li>Facial Hair (N/A for Cheerleader)</li>
                        <li>Hair</li>
                        <li>Mouth</li>
                        <li>Jewelry</li>
                        <li>Eyewear</li>
                        <li>Headwear</li>
                        <li>Accessory Left</li>
                        <li>Accessory Right</li>
                    </ul>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem faqSlug="fanepack" uuid="fanepack">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <div className="lg:hidden faq-number">4</div>
                        <div className="flex justify-between items-center mt-5 xl:mt-0">
                            <div className="w-[calc(100%-3rem)] flex items-start gap-5 numbered-faq">
                                <span className="hidden lg:flex faq-number">4</span>
                                <h2 className="lt-white font-bold">What is a FanEpack?</h2>
                            </div>
                            <div className="open-img w-[2.8rem]">
                                <img className="w-full" src={open} alt="Open FAQ"/>
                            </div>
                        </div>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="text-grey">
                    <p className="text-grey">When a Genesis Metafan is minted, a FanEpack is provided to the minter as a free gift.  FanEpack holders receive enhanced benefits from certain community activities. FanEpacks act as a prize multiplier and, in some cases, make holders eligible for exclusive access to games and activities.</p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem faqSlug="artist" uuid="artist">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <div className="lg:hidden faq-number">5</div>
                        <div className="flex justify-between items-center mt-5 xl:mt-0">
                            <div className="w-[calc(100%-3rem)] flex iitems-start gap-5 numbered-faq">
                                <span className="hidden lg:flex faq-number">5</span>
                                <h2 className="lt-white font-bold">Who is the artist behind MetaFans?</h2>
                            </div>
                            <div className="open-img w-[2.8rem]">
                                <img className="w-full" src={open} alt="Open FAQ"/>
                            </div>
                        </div>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="text-grey">
                    <p className="text-grey">Maxfield Bala is an internationally renowned illustrator and fine artist working with brands like Disney, the NFL, Coca-Cola, and Samsung on collaborative artistic projects seen around the world. From fine line illustration to large-scale murals Maxfield Bala's diverse use of artistic mediums has developed a unique artistic style coveted by collectors. NFTS has allowed Bala's artwork to further transcend into the digital space as part of his first NFT collection. The collection of 10,000 computer-generated characters possesses extremely detailed properties and Variants that reflect the wild artistic style and mind of Maxfield Bala. Sized at 4000x4000 pixels, these high-resolution images allow the user to interact with every brush stroke and graphic line these characters have to offer.</p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem faqSlug="benefits" uuid="benefits">
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <div className="lg:hidden faq-number">6</div>
                        <div className="flex justify-between items-center mt-5 xl:mt-0">
                            <div className="w-[calc(100%-3rem)] flex items-start gap-5 numbered-faq">
                                <span className="hidden lg:flex faq-number">6</span>
                                <h2 className="lt-white font-bold">What are the benefits of owning a MetaFan NFT?</h2>
                            </div>
                            <div className="open-img w-[2.8rem]">
                                <img className="w-full" src={open} alt="Open FAQ"/>
                            </div>
                        </div>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="text-grey">
                    <ul className="text-grey">
                        <li>Ticket giveaways for IRL VIP experiences to concerts, sporting events, and more.</li>
                        <li>Access to exclusive holder events including our VIP Gatherings for major sporting events.</li>
                        <li>Access to an amazing community of like-minded people with daily games and chances to win!</li>
                        <li>Coming soon! Our Clubhouse app is under development and will launch in time for football season! This app will provide an exclusive Web 3.0 space for our community and will include access to eliminator pools, pick ‘ems, and more!</li>
                    </ul>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
            </div>
        </section>
    );
};

export default Faqs;